import { FilterSet } from '#server/models';
import { ActiveFilters } from '@/store';

export const countFilters = (filterData: FilterSet | null | undefined, activeFilters: ActiveFilters) => {
  return (filterData ?? []).reduce((sum, f) => {
    const v = activeFilters[f.title];
    if (!v) return sum;

    if (f.type === 'slider' || f.type === 'date-range') {
      return sum + 1;
    }

    return Array.isArray(v) ? sum + v.length : sum;
  }, 0);
};
